import { render, staticRenderFns } from "./FacebookCampaignInsight.vue?vue&type=template&id=15ac8556"
import script from "./FacebookCampaignInsight.vue?vue&type=script&lang=js"
export * from "./FacebookCampaignInsight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports